module.exports = __webpack_public_path__ + "img/2.41a1e723.jpg";